import { sectionTypes } from '../enums';

export const CTA_OPTIONS = {
  URL_OPTIONS: {
    text:  'Destination URL',
    value: 'url',
  },
  GO_TO_FORM: {
    text:  'Go to the Form',
    value: 'action:goToForm',
  },
  CONTENT_PAGE: {
    text:  'Content Page',
    value: 'action:content',
  },
};

export const getOptions = (isBeforeForm, isCTADropdownAllowed = true) => {
  const defaultOptions = [CTA_OPTIONS.URL_OPTIONS];
  const allOptions = [...defaultOptions];
  const allowedActions = [];
  const forbiddenActions = [];

  if (isCTADropdownAllowed) {
    allOptions.push(CTA_OPTIONS.GO_TO_FORM);
  }

  if (isBeforeForm) {
    allowedActions.push(CTA_OPTIONS.GO_TO_FORM);
  } else {
    forbiddenActions.push(CTA_OPTIONS.GO_TO_FORM);
  }

  const dropdownOptions = [...defaultOptions, ...allowedActions];

  return {
    urlOption: CTA_OPTIONS.URL_OPTIONS,

    allowedActions,
    forbiddenActions,
    allOptions,
    dropdownOptions,
  };
};

export const getIsCTABeforeForm = (moduleId, orderedLayoutIds, layoutsById, updatedLayoutId, updatedLayout) => {
  if (!moduleId) {
    return false;
  }

  for (const layoutId of orderedLayoutIds) {
    const config =
      layoutId === updatedLayoutId ? updatedLayout : layoutsById[layoutId] ? layoutsById[layoutId].layoutConfig : null;

    if (!config || !config.pageLayout || !config.pageLayout.sections) {
      return false;
    }

    for (const section of config.pageLayout.sections) {
      if (section.type === sectionTypes.FORM) {
        return false;
      }

      const isSearchModuleExists = section.rows.some((row) =>
        row.columns.some((column) => column.modules.includes(moduleId))
      );

      if (isSearchModuleExists) {
        return true;
      }
    }
  }

  return false;
};

export const getIsCTALinkCorrect = (link, isBeforeForm) =>
  !getOptions(isBeforeForm).forbiddenActions.some((action) => action.value === link);
